import * as angular from 'angular';

export class Controller {

    /** @ngInject */
    constructor(Alert, ConfirmDeleteModal, UserNotesService,$state,$stateParams) {
        this.Alert = Alert;
        this.ConfirmDeleteModal = ConfirmDeleteModal;
        this.UserNotesService = UserNotesService;
        this.$state=$state;
    }

    $onInit() {
	    this.theNote=this.note;
		if(this.theNote==null){
			 this.$state.go('^');
		}
        this.note = {...this.theNote};
    }

    notModified() {
        return angular.equals(this.note, this.theNote);
    }

    remove() {
        this.isRemoving = true;
        this.ConfirmDeleteModal('company.sharing-center.confirm_company_note_delete')
            .then(() => this.UserNotesService.delete({id : this.note.id}).$promise)
            .then(() => {
                this.$state.go('^', {}, { reload: '^' });
                this.Alert('success', 'company.sharing-center.note.manage.removed');
            })
            .finally(() => this.isRemoving = false)
    }

    save() {
		this.isSaving = true;
        this.UserNotesService.save(this.note).$promise
            .then(note => {
                this.$state.go('.', {}, { reload: '^' });
                this.Alert('success', 'company.sharing-center.note.manage.saved');
            })
            .finally(() => this.isSaving = false)
       
    }

    saveDisabled(form) {
        return this.isSaving || form.$invalid || this.notModified();
    }
}




// WEBPACK FOOTER //
// ./src/portal/states/user/notes/edit/edit-note.controller.js